import { render, staticRenderFns } from "./CustomerListModal.vue?vue&type=template&id=5a2277cf&"
import script from "./CustomerListModal.vue?vue&type=script&lang=js&"
export * from "./CustomerListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports